import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://pioneer2-service.qa.onyxcentersource.com',
  hostname: 'pioneer2.qa.onyxcentersource.com',
  portalUrl: 'https://portal.qa.onyxcentersource.com',
  onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
  invoiceHistoryUrl: 'https://ooiv-invoice-history2.qa.onyxcentersource.com',
  emailValidation: true,
  allowApiDocs: true,
  agencyDashboardUrl: 'https://agency-dashboard2.qa.onyxcentersource.com',
  showAgencyDashboard: true
};



export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.qa2.ts